import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBTgtEgUEVieNQ-GlvMZvPHpJXSgx-UBBQ",
  authDomain: "rogue-stickers.firebaseapp.com", // Same domain for dev and prod - handles redirects
  projectId: "rogue-stickers",
  storageBucket: "rogue-stickers.firebasestorage.app",
  messagingSenderId: "505225364426",
  appId: "1:505225364426:web:76d2fdd5dcea5d38f84533",
  measurementId: "G-V9HBBMD8X0",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
